import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.phone || !formData.email || !formData.message) {
      alert('必須項目をすべて入力してください。');
      return;
    }

    if (formData.message.length > 500) {
      alert('お問い合わせ内容は500文字以内で入力してください。');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('phone', formData.phone);
      formBody.append('email', formData.email);
      formBody.append('service', formData.service);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6e29riohb161tfd8qj0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          email: '',
          service: '',
          message: '',
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/5fc21a18e30889b56e0e1b9daacd7301.png)',
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/30 to-black/40"></div>
        
        <div className="relative z-10 text-center px-4">
          <h1 className="text-5xl md:text-6xl font-serif text-white mb-4">お問い合わせ</h1>
          <p className="text-lg text-white/90">Contact Us</p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-6">
              お気軽にご相談ください
            </h2>
            <p className="text-base text-gray-600 leading-relaxed">
              お問い合わせフォームより、お気軽にご連絡ください。<br />
              専門スタッフが丁寧に対応いたします。
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <div className="bg-white rounded-lg border border-gray-200 p-8">
                <h3 className="text-2xl font-serif text-gray-800 mb-6">会社情報</h3>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <i className="ri-building-line text-xl text-[#A7D676] mt-1"></i>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">会社名</p>
                      <p className="text-base text-gray-800">株式会社飛翠</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-map-pin-line text-xl text-[#A7D676] mt-1"></i>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">所在地</p>
                      <p className="text-base text-gray-800">神奈川県横浜市中区石川町1丁目13番地2<br />エネクル横浜元町テラス1F</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-map-2-line text-xl text-[#A7D676] mt-1"></i>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">対応エリア</p>
                      <p className="text-base text-gray-800">一都三県（東京都、神奈川県、埼玉県、千葉県）</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-time-line text-xl text-[#A7D676] mt-1"></i>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">営業時間</p>
                      <p className="text-base text-gray-800">9:00〜18:00（年中無休）</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg border border-gray-200 p-8 mt-6 text-center">
                <h3 className="text-xl font-serif text-gray-800 mb-4">LINEでもお問い合わせいただけます</h3>
                <div className="flex items-center justify-center gap-2 mb-4">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-chat-smile-2-fill text-[#06C755] text-lg"></i>
                  </span>
                  <p className="text-sm text-gray-700">お気軽にメッセージください</p>
                </div>
                <a
                  href="https://lin.ee/FOUdDfw"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-block cursor-pointer"
                >
                  <img
                    src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png"
                    alt="友だち追加"
                    className="h-10 w-auto"
                  />
                </a>
                <p className="text-xs text-gray-500 mt-4 leading-relaxed">
                  LINEなら24時間いつでもメッセージを送ることができ、<br />返信も迅速に対応いたします。
                </p>
              </div>
            </div>

            <div>
              <div className="bg-white rounded-lg border border-gray-200 p-8">
                <h3 className="text-2xl font-serif text-gray-800 mb-6">お問い合わせフォーム</h3>
                
                {submitStatus === 'success' && (
                  <div className="bg-[#A7D676]/10 border border-[#A7D676] rounded-lg p-4 mb-6">
                    <p className="text-sm text-gray-800">
                      <i className="ri-check-line text-[#A7D676] mr-2"></i>
                      お問い合わせを受け付けました。担当者より折り返しご連絡いたします。
                    </p>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-300 rounded-lg p-4 mb-6">
                    <p className="text-sm text-red-800">
                      <i className="ri-error-warning-line text-red-500 mr-2"></i>
                      送信に失敗しました。お手数ですが、もう一度お試しください。
                    </p>
                  </div>
                )}

                <form id="contact-form" onSubmit={handleSubmit} data-readdy-form>
                  <div className="space-y-5">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-800 mb-2">
                        お名前 <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#A7D676] focus:border-transparent"
                        placeholder="山田 太郎"
                      />
                    </div>

                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-800 mb-2">
                        電話番号 <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#A7D676] focus:border-transparent"
                        placeholder="090-1234-5678"
                      />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-800 mb-2">
                        メールアドレス <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#A7D676] focus:border-transparent"
                        placeholder="example@email.com"
                      />
                    </div>

                    <div>
                      <label htmlFor="service" className="block text-sm font-medium text-gray-800 mb-2">
                        ご希望のサービス
                      </label>
                      <select
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#A7D676] focus:border-transparent cursor-pointer"
                      >
                        <option value="">選択してください</option>
                        <option value="出張買取">出張買取</option>
                        <option value="家財撤去">家財撤去</option>
                        <option value="ハウスクリーニング">ハウスクリーニング</option>
                        <option value="家電修理">家電修理</option>
                        <option value="リフォーム">リフォーム</option>
                        <option value="その他">その他</option>
                      </select>
                    </div>

                    <div>
                      <label htmlFor="message" className="block text-sm font-medium text-gray-800 mb-2">
                        お問い合わせ内容 <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        maxLength={500}
                        rows={6}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#A7D676] focus:border-transparent resize-none"
                        placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                      ></textarea>
                      <p className="text-xs text-gray-500 mt-1 text-right">
                        {formData.message.length} / 500文字
                      </p>
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full bg-[#A7D676] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#96c565] transition-colors shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                    >
                      {isSubmitting ? '送信中...' : '送信する'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
